import { GpsSelectedPortOutput } from './gps-selected-port-output.model';


export class GpsDeviceWithOutStatusOutputData implements IGpsDeviceWithOutStatusOutputData {
    /** The auto-generated id of the device master */
    gps_device_id!: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;
    /** The device name 500 character */
    device_name!: string;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The auto-generated id of the sim card master */
    sim_card_details_id!: number;
    /** The auto-generated id of the sim card master */
    secondary_sim_card_details_id!: number;
    /** The IMEI number with 500 character */
    imei_number!: string;
    /** The auto-generated id of the device model master */
    device_model_id!: number;
    /** The auto-generated id of the device brand master */
    device_brand_id!: number;
    /** The auto-generated id of the time zone master */
    time_zone_id!: number;
    /** The expiry date should be with 10 character */
    installation_date!: string;
    /** The special feature with 10 character */
    special_feature!: string;
    /** The automatic config should be 0 or 1 */
    automatic_config!: number;
    /** The refresh intervale */
    refresh_interval!: number;
    /** The device password with 200 character */
    device_password!: string;
    /** The refresh intervale */
    data_interval!: number;
    /** The distance calculation should be "Odometer" or "lating"  */
    distance_calculation!: string;
    /** The distance calculation should be "Direct" or "From Lating"  */
    speed_calculation!: string;
    /** The vehicle license 0 for unselected, 1 for selected */
    vehicle_license!: number;
    /** The vehicle rfid timeout duration */
    rfid_timeout_duration!: number;
    /** The expiry date should be with 10 character */
    expiry_date!: string;
    /** The notify 0 for unselected, 1 for selected */
    notify!: number;
    /** The show expiryMessage days */
    show_expiry_message_days!: number;
    /** The fuel consumption based on  should be  "Distance" or "Duration" */
    device_distance_variation_percentage!: string;
    /** The fuel consumption with 200 character limit */
    device_distance_variation!: string;
    /** Manage status of device. 0 For De-active, 1 For Active */
    status!: number;
    selected_gps_device_port_specification!: GpsSelectedPortOutput[];

    constructor(data?: IGpsDeviceWithOutStatusOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gps_device_id = _data["gps_device_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.device_name = _data["device_name"];
            this.company_details_id = _data["company_details_id"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.sim_card_details_id = _data["sim_card_details_id"];
            this.secondary_sim_card_details_id = _data["secondary_sim_card_details_id"];
            this.imei_number = _data["imei_number"];
            this.device_model_id = _data["device_model_id"];
            this.device_brand_id = _data["device_brand_id"];
            this.time_zone_id = _data["time_zone_id"];
            this.installation_date = _data["installation_date"];
            this.special_feature = _data["special_feature"];
            this.automatic_config = _data["automatic_config"];
            this.refresh_interval = _data["refresh_interval"];
            this.device_password = _data["device_password"];
            this.data_interval = _data["data_interval"];
            this.distance_calculation = _data["distance_calculation"];
            this.speed_calculation = _data["speed_calculation"];
            this.vehicle_license = _data["vehicle_license"];
            this.rfid_timeout_duration = _data["rfid_timeout_duration"];
            this.expiry_date = _data["expiry_date"];
            this.notify = _data["notify"];
            this.show_expiry_message_days = _data["show_expiry_message_days"];
            this.device_distance_variation_percentage = _data["device_distance_variation_percentage"];
            this.device_distance_variation = _data["device_distance_variation"];
            this.status = _data["status"];
            if (Array.isArray(_data["selected_gps_device_port_specification"])) {
                this.selected_gps_device_port_specification = [] as any;
                for (let item of _data["selected_gps_device_port_specification"])
                    this.selected_gps_device_port_specification!.push(GpsSelectedPortOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GpsDeviceWithOutStatusOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new GpsDeviceWithOutStatusOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gps_device_id"] = this.gps_device_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["device_name"] = this.device_name;
        data["company_details_id"] = this.company_details_id;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["sim_card_details_id"] = this.sim_card_details_id;
        data["secondary_sim_card_details_id"] = this.secondary_sim_card_details_id;
        data["imei_number"] = this.imei_number;
        data["device_model_id"] = this.device_model_id;
        data["device_brand_id"] = this.device_brand_id;
        data["time_zone_id"] = this.time_zone_id;
        data["installation_date"] = this.installation_date;
        data["special_feature"] = this.special_feature;
        data["automatic_config"] = this.automatic_config;
        data["refresh_interval"] = this.refresh_interval;
        data["device_password"] = this.device_password;
        data["data_interval"] = this.data_interval;
        data["distance_calculation"] = this.distance_calculation;
        data["speed_calculation"] = this.speed_calculation;
        data["vehicle_license"] = this.vehicle_license;
        data["rfid_timeout_duration"] = this.rfid_timeout_duration;
        data["expiry_date"] = this.expiry_date;
        data["notify"] = this.notify;
        data["show_expiry_message_days"] = this.show_expiry_message_days;
        data["device_distance_variation_percentage"] = this.device_distance_variation_percentage;
        data["device_distance_variation"] = this.device_distance_variation;
        data["status"] = this.status;
        if (Array.isArray(this.selected_gps_device_port_specification)) {
            data["selected_gps_device_port_specification"] = [];
            for (let item of this.selected_gps_device_port_specification)
                data["selected_gps_device_port_specification"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGpsDeviceWithOutStatusOutputData {
    /** The auto-generated id of the device master */
    gps_device_id: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
    /** The device name 500 character */
    device_name: string;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The auto-generated id of the sim card master */
    sim_card_details_id: number;
    /** The auto-generated id of the sim card master */
    secondary_sim_card_details_id: number;
    /** The IMEI number with 500 character */
    imei_number: string;
    /** The auto-generated id of the device model master */
    device_model_id: number;
    /** The auto-generated id of the device brand master */
    device_brand_id: number;
    /** The auto-generated id of the time zone master */
    time_zone_id: number;
    /** The expiry date should be with 10 character */
    installation_date: string;
    /** The special feature with 10 character */
    special_feature: string;
    /** The automatic config should be 0 or 1 */
    automatic_config: number;
    /** The refresh intervale */
    refresh_interval: number;
    /** The device password with 200 character */
    device_password: string;
    /** The refresh intervale */
    data_interval: number;
    /** The distance calculation should be "Odometer" or "lating"  */
    distance_calculation: string;
    /** The distance calculation should be "Direct" or "From Lating"  */
    speed_calculation: string;
    /** The vehicle license 0 for unselected, 1 for selected */
    vehicle_license: number;
    /** The vehicle rfid timeout duration */
    rfid_timeout_duration: number;
    /** The expiry date should be with 10 character */
    expiry_date: string;
    /** The notify 0 for unselected, 1 for selected */
    notify: number;
    /** The show expiryMessage days */
    show_expiry_message_days: number;
    /** The fuel consumption based on  should be  "Distance" or "Duration" */
    device_distance_variation_percentage: string;
    /** The fuel consumption with 200 character limit */
    device_distance_variation: string;
    /** Manage status of device. 0 For De-active, 1 For Active */
    status: number;
    selected_gps_device_port_specification: GpsSelectedPortOutput[];
}

